(function ($) {
	var methods = {
		init: function () {
			return this.each(function () {
				var $this = $(this);
				var data = $this.data('inputFIO');
				
				if (!data) {
					$this.data('inputFIO', {
						target: $this
					});
					
	
					// что форматируем
					function formatValue(value) {
						//value = value.replace(/[^-\ а-яА-Яё]/g, ''); 
						/*
						убираем все кроме:
						а-яА-ЯёЁ  - все русские буквы включая ё
						\-  - дефис (экранированный)
						\s  - пробел
						\.  - точка (экранированная)
						IV  - латинские прописные буквы I и V
						\' - апостроф (экранированный)
						\,  - запятая (экранированная)
						\( и \) - скобки
						*/
						value = value.replace(/[^а-яА-ЯёЁ\-\s\.\IV\'\,\(\)]/g, '');
						
						value = value.replace(/\){2,}/g, ')');  // убираем двойную левую скобку
						value = value.replace(/\({2,}/g, '(');  // убираем двойную правую скобку
						value = value.replace(/\'{2,}/g, '\'');  // убираем двойной апостро
						value = value.replace(/\.{2,}/g, '.');  // убираем двойную точку
						value = value.replace(/\s{2,}/g, ' ');  // убирает двойной пробел
						value = value.replace(/\-{2,}/g, '-');  // убирает двойной дефис
						value = value.trimStart(); // убирает пробел в самом начале
						value = value.replace(/\-\s+/g, '-');  // убирает пробел после дефиса
						return value;
					}
					
					function parse(event) {
						const target = event.target;
						const formattedValue = formatValue(target.value);
						const cursor = target.selectionStart;

						// если пусто, то дальше не идем
						if (formattedValue === "") {
							target.value = ""
							return ""
						}
						
						const words = formattedValue.split(' '); // каждый раз делим на слова по пробелам 
						let parseResult = '';

						words.forEach(function (word, idx) {
							// слово не начинается с тире
							if (word[0] === '-') {
								return;
							}

							// если слово не первое, добавляем пробел
							if (idx > 0) {
								parseResult += " "
							}

							// первая буква каждого слова в верхнем регистре
							parseResult += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
						});
						
						// если значение тоже самое, то не меняем его
						if (target.value !== parseResult) {
							target.value = parseResult;
							
							target.selectionStart = cursor
							target.selectionEnd = cursor;
						}

						return parseResult;
					}
					
					// работает после вставки значения в инпут
					$this.on('input.inputFIO', function (event) {
						event = event.originalEvent || event;
						
						
						parse(event);
						
						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
					});
				}

			});

		},
		destroy: function () {
			return this.each(function () {
				var $this = $(this);
				$this.removeData('inputFIO');
				$(window).unbind('.inputFIO');
			});

		}
	};
	$.fn.inputFIO = function (method) {
		if (methods[method]) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Метод с именем ' + method + ' не существует для jQuery.inputFIO');
		}
	};
})(jQuery);

